// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7f19e3cd","453":"fe3b160c","732":"be294daa","977":"51c9add9"}[chunkId] + ".chunk.js";
};